const UNITS = { g: ['g', 1], kg: ['g', 1000], ml: ['ml', 1], cl: ['ml', 10], dl: ['ml', 100], l: ['ml', 1000] };

const parse = (q) => {
  const m = (q || '').trim().toLowerCase().match(/^(\d+(?:[.,]\d+)?)\s*([a-zåäö]*)\.?$/);
  return m ? { n: parseFloat(m[1].replace(',', '.')), u: m[2] } : null;
};
const fmt = (n) => String(Math.round(n * 100) / 100).replace('.', ',');

export function sumQty(qtys) {
  const list = qtys.filter(Boolean);
  if (list.length < 2) return list[0] || '';
  const ps = list.map(parse);
  if (ps.some((p) => !p)) return list.join(' + ');
  const bases = ps.map((p) => (UNITS[p.u] ? UNITS[p.u][0] : p.u));
  if (new Set(bases).size !== 1) return list.join(' + ');
  const base = bases[0];
  const total = ps.reduce((s, p) => s + p.n * (UNITS[p.u] ? UNITS[p.u][1] : 1), 0);
  if (base === 'g') return total >= 1000 ? `${fmt(total / 1000)} kg` : `${fmt(total)} g`;
  if (base === 'ml') return total >= 1000 ? `${fmt(total / 1000)} l` : total >= 100 ? `${fmt(total / 100)} dl` : `${fmt(total)} ml`;
  return `${fmt(total)}${base ? ` ${base}` : ''}`;
}

// Same ingredient in the same aisle becomes one line with the total amount.
export function mergeItems(items) {
  const groups = new Map();
  items.forEach((it) => {
    const k = `${it.aisle}|${it.name.trim().toLowerCase()}`;
    if (!groups.has(k)) groups.set(k, []);
    groups.get(k).push(it);
  });
  return [...groups.values()].map((g) => (g.length === 1 ? { ...g[0], ids: [g[0].id] } : {
    ...g[0],
    ids: g.map((x) => x.id),
    qty: sumQty(g.map((x) => x.qty)),
    dinner: [...new Set(g.map((x) => x.dinner).filter(Boolean))].join(' & '),
    checked: g.every((x) => x.checked),
    merged: g.length,
  }));
}
